// import {
//   Alert,
//   AlertIcon,
//   AlertTitle,
//   Button,
//   CloseButton,
//   Modal,
//   ModalBody,
//   ModalCloseButton,
//   ModalContent,
//   ModalFooter,
//   ModalHeader,
//   ModalOverlay,
//   Text,
//   useToast,
// } from "@chakra-ui/react";
// import axios from "axios";
// import React, { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { REQUEST_DELETE_MASTER_CASESTUDY } from "../../store/casestudy/casestudyActionTypes";
// import { useCasestudyMaster } from "../../store/casestudy/reducer";
// interface RestaurantDeleteProps {
//   bannerData: any;
//   // bannerData: any;
//   isOpen: boolean;
//   // onClose: () => void;
//   onDeleteClose: () => void;
//   refreshData?: () => void;
//   // refreshData?: any[];
//   categoryFilter?: string;
// }
// const CasestudyUnlinkedConfirmation: React.FC<RestaurantDeleteProps> = ({
//   isOpen,
//   // onClose,
//   bannerData,
//   onDeleteClose,
//   refreshData,
//   categoryFilter,
// }) => {
//   const dispatch = useDispatch();
//   const { masterCasestudy: events, busy, message } = useCasestudyMaster();
//   const toast = useToast();

//   const handleDelete = async () => {
//     try {
//       const response = await axios.patch(
//         `${process.env.REACT_APP_API_URL}admin/category/unlinkCategory?categoryId=67737faaa295575aa7affbe7&serviceId=68023ca1b71cbfa5faa6e651`,
//         {
//           isLinked: false,
//         }
//       );
//     } catch {}
//   };

//   return (
//     <Modal isOpen={isOpen} onClose={onDeleteClose} closeOnOverlayClick={false}>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader>Delete selected casestudy</ModalHeader>
//         <ModalCloseButton disabled={busy} />
//         <ModalBody>
//           <Text fontWeight="bold" mb="1rem">
//             {`Are you sure you want to delete this Restaurant?`}
//           </Text>
//         </ModalBody>
//         <ModalFooter>
//           <Button
//             variant="outline"
//             mr={3}
//             onClick={onDeleteClose}
//             disabled={busy}
//           >
//             Close
//           </Button>
//           <Button
//             colorScheme="red"
//             variant={"outline"}
//             mr={3}
//             disabled={busy}
//             onClick={handleDelete}
//           >
//             Submit
//           </Button>
//         </ModalFooter>
//         {message && (
//           <ModalFooter>
//             <Alert status="error">
//               <AlertIcon /> <AlertTitle mr={2}>{message}</AlertTitle>
//               <CloseButton position="absolute" right="8px" top="8px" />
//             </Alert>
//           </ModalFooter>
//         )}
//       </ModalContent>
//     </Modal>
//   );
// };
// export default CasestudyUnlinkedConfirmation;
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

interface CasestudyUnlinkedProps {
  bannerData: {
    serviceId: string;
    categoryId: string;
  };
  isOpen: boolean;
  onDeleteClose: () => void;
  refreshData?: () => void;
}

const CasestudyUnlinkedConfirmation: React.FC<CasestudyUnlinkedProps> = ({
  isOpen,
  bannerData,
  onDeleteClose,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const handleUnlink = async () => {
    setBusy(true);
    setMessage("");

    const tkn = localStorage.getItem("token");
    if (!tkn) {
      toast({
        title: "Error",
        description: "Please login to continue",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      setBusy(false);
      return;
    }

    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/admin/category/unlinkCategory?categoryId=${bannerData.categoryId}&serviceId=${bannerData.serviceId}`,
        {
          headers: {
            Authorization: `${tkn}`,
          },
        }
      );

      toast({
        title: "Success",
        description: "Case study unlinked successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      if (refreshData) {
        refreshData();
      }

      onDeleteClose();
    } catch (error: any) {
      console.error("Error unlinking case study:", error);
      setMessage(
        error.response?.data?.message || "Failed to unlink case study"
      );
      toast({
        title: "Error",
        description: "Failed to unlink case study",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onDeleteClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Unlink Case Study</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure you want to unlink this case study from the service?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={onDeleteClose}
            disabled={busy}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            variant="outline"
            mr={3}
            isLoading={busy}
            onClick={handleUnlink}
          >
            Unlink
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon /> <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CasestudyUnlinkedConfirmation;
